import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import CurrencyInput from 'react-currency-input-field';
import { SafeAreaView, StyleSheet, TextInput } from 'react-native';
import TransactionCardList from "./TransactionCardList.js";
import '../Styles/ViewTransactionHistory.scss';


function ViewTransactionHistory({regist_id, setViewTransactionsVisibility}) {

   const params = useParams()
   const [isDeafCamper, setIsDeafCamper] = useState(false)
   const [promoRedeemed, setPromoRedeemed] = useState(false)
   const [noTransactionsMessage, setNoTransactionsMessage] = useState(false)
   const [transactions, setTransactions] = useState()
   const [registration, setRegistration] = useState()

   async function GetTransactionsOnPageLoad(){

      const registId = regist_id
         const transactionsRequest = await fetch('/getselectedtransactions', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               registId
            })
         })
   
         const transactionsResponse = await transactionsRequest.json();
         console.log("transactions", transactionsResponse.data.transactions)
         let selectedTransactions = transactionsResponse.data.transactions
         setTransactions(selectedTransactions)

         // If no transactions, check registration information
         if(selectedTransactions == ''){
            const registId = regist_id
            const registrationRequest = await fetch('/getselectedregistration', {
               method: 'POST',
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({
                  registId
               })
            })  
            const registrationResponse = await registrationRequest.json()
            console.log("Registration", registrationResponse)
            const registration = registrationResponse.data.selectedRegistration[0]
            console.log("Registration", registration)
            if(registration.promo_used === true)
            {
               setPromoRedeemed(true)
               setRegistration(registration)
            }
            else if(registration.is_free_deaf_camper === true)
            {
               setIsDeafCamper(true)
            }
            else{
               setNoTransactionsMessage(true)
            }

         }
   }

   useEffect(() => {
      GetTransactionsOnPageLoad()
   }, []);

   return(
         <div className="TransactionHistoryContainer">
            <div className="TransactionHistoryContent">
               <div className="TransactionHistoryHeading">
                  Transaction History
               </div>
               <div className="TransactionHistoryRecords">
                   <div className="TransactionHistoryPaymentList">
                     <TransactionCardList
                     transactions={transactions}/>
                  </div>
               </div>
               {isDeafCamper == true &&
                  <div className="FreeDeafWeekNotification">
                     Deaf camp is free of charge, no camp fee. 
                  </div>
               }
               {promoRedeemed == true &&
                  <div className="PromoCodeNotification">
                     Promo code for free camp week redeemed on {DateHelpers.getDisplayDate(registration.regist_date)}
                  </div>
               }
               {noTransactionsMessage === true &&
                  <div className="NoTransactionsNotification">
                     No transactions have been recorded for this registration.
                  </div>
               }
               <div className="TransactionHistoryCloseButton">
                  <button onClick={() => setViewTransactionsVisibility(false)}>
                     Close
                  </button>
               </div>
            </div>
         </div>
   
   )
}
export default ViewTransactionHistory